/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {ENV} from '../../../../app/Utils/_helpers/EnvHelper'
import { getAllUserDetails } from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useSelector } from 'react-redux'

const AsideDefault: FC = () => {
  const param = document.location.host
  const userData: any = useSelector(getAllUserDetails)

  const [logo, setLogo] = useState<any>(false)
  const [active, setActive] = useState<any>(false)
  const {classes} = useLayout()

  return (
    <div
      id='kt_aside'
      className={`aside aside-light  ${active && 'aside-hoverable'}`}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {logo === false ? (
          <Link to='/dashboard'>
            {userData?.customLogo ? (
              <img alt='Logo' src={userData?.customLogo} className='h-30px' />
            ) : (
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/Logo.svg')} className='h-30px' />
            )}
          </Link>
        ) : (
          <Link to='/dashboard'>
            {param !== ENV().REACT_APP_CELLCAST ? (
              <></>
            ) : (
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/LogoSymbol.svg')}
                className='h-30px'
              />
            )}
          </Link>
        )}

        {/* begin::Aside toggler */}
        {/* {aside.minimize && (
   
        )} */}
        <div
          id='kt_aside_toggle'
          className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
          data-kt-toggle='true'
          data-kt-toggle-state='active'
          data-kt-toggle-target='body'
          data-kt-toggle-name='aside-minimize'
          onClick={() => {
            setTimeout(() => {
              setActive(!active)
            }, 1000)
          }}
        >
          <KTSVG
            path={'/media/icons/duotune/arrows/arr080.svg'}
            className={'svg-icon-1 rotate-180'}
            onClick={() => setLogo(!logo)}
          />
        </div>

        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid pt-3'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      {/* {isAdmin === 'true' ? null : (
        <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
          {AuthenticateUser('send-quick-sms') && (
            <Link
              to={'/new-message'}
              className={`btn btn-custom  w-100 ${
                url?.pathname == '/new-message' ? 'grayButton' : 'btn-primary'
              } `}
            >
              <span className='btn-label fs-6'>Send new campaign</span>
              <span className='svg-icon btn-icon svg-icon-2'>
                <KTSVG path='/media/icons/duotune/general/gen005.svg' />
              </span>
            </Link>
          )}
        </div>
      )} */}
      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
